export const preloadImage = (url: string): Promise<void> =>
  new Promise((resolve, reject) => {
    const i = new Image();
    i.addEventListener("load", () => resolve());
    i.addEventListener("error", () => reject(new Error("Image load error")));
    i.src = url;
  });
